import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './style.css'

// Display build information in console
console.log('%c🚀 File Share App', 'color: #3b82f6; font-size: 16px; font-weight: bold;')
console.log('%cBuild Information:', 'color: #059669; font-weight: bold;')
console.log(`📅 Build Timestamp: ${__BUILD_TIMESTAMP__}`)
console.log(`🏷️  Version: ${__BUILD_VERSION__}`)
console.log(`🌐 Environment: ${import.meta.env.MODE}`)
console.log(`⚡ Vite: ${import.meta.env.DEV ? 'Development' : 'Production'} mode`)

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
